import type { HField } from "../types/scene";

export const STANDARD_FLOOR_HFIELD_NAME = "standard_floor_terrain";

/** Upper bound for `heightScale` (matches Terrain panel total-height slider range). */
export const MAX_HFIELD_HEIGHT_SCALE = 12;

export function getStandardFloorHField(
  hfields: Record<string, HField> | null | undefined
): HField | null {
  return hfields?.[STANDARD_FLOOR_HFIELD_NAME] ?? null;
}

/**
 * Returns the same hfield reference if scale is 1; otherwise a shallow copy whose `size[2]`
 * is multiplied by `heightScale` (defaults to 1, clamped to >= 0 and <= MAX_HFIELD_HEIGHT_SCALE).
 * Use for Three.js geometry and MJCF export so store `size[2]` stays the preset/base elevation.
 */
export function getHFieldWithAppliedHeightScale(
  hfield: HField | null | undefined
): HField | null | undefined {
  if (!hfield || !Array.isArray(hfield.size) || hfield.size.length < 3) return hfield;
  const scaleRaw = hfield.heightScale;
  let scale = Number.isFinite(Number(scaleRaw)) && Number(scaleRaw) >= 0 ? Number(scaleRaw) : 1;
  scale = Math.min(MAX_HFIELD_HEIGHT_SCALE, scale);
  if (scale === 1) return hfield;
  const baseZ = Number(hfield.size[2]);
  if (!Number.isFinite(baseZ)) return hfield;
  const size = [...hfield.size] as [number, number, number, number];
  size[2] = baseZ * scale;
  return { ...hfield, size };
}
